import {
  trackClickEvent,
  trackPageViewedEvent,
} from '../GlintsTracking/tracking';

type PasswordResetPageState = {
  id?: string;
  token?: string;
  newUser?: boolean;
};

export function getPasswordResetPageName({
  id,
  token,
  newUser,
}: PasswordResetPageState) {
  if (!id || !token) return 'forgot_password';
  return newUser ? 'create_password' : 'reset_password';
}

export function trackPasswordResetPageViewed(state: PasswordResetPageState) {
  trackPageViewedEvent({ pageName: getPasswordResetPageName(state) });
}

export function trackPasswordResetClick(
  elementName: string,
  newUser = false,
  success?: boolean
) {
  const pageName =
    elementName === 'send_reset_instructions'
      ? 'forgot_password'
      : newUser
        ? 'create_password'
        : 'reset_password';
  trackClickEvent({
    elementName:
      newUser && elementName === 'reset_password'
        ? 'create_password'
        : elementName,
    pageName,
    useTargetPageName: true,
    properties: success === undefined ? {} : { success },
  });
}
